import type { DocPageContent } from '../docs-content'

const page = {
  order: 14,
  slug: 'transitions',
  title: '转场',
  description: '应用转场、调整时长、位置、缓动、方向和手柄。',
  category: '创意工具',
  sections: [
    {
      title: '应用转场',
      items: [
        '将转场拖放到时间线上的有效剪切点。',
        '当选中的片段和相邻剪切点支持时，点击应用。',
        '使用基础、溶解、运动、擦除、滑动、翻转、蒙版、光圈、形状、光线和色差等转场分类。',
      ],
    },
    {
      title: '转场控件',
      items: [
        '在转场设置中调整时长。',
        '将位置设置为剪切点左侧、居中或右侧。',
        '当转场支持时选择缓动和方向。',
        '在可用时直接在时间线上调整转场大小。',
      ],
    },
    {
      title: '常见问题',
      items: [
        '转场需要一个有效的视觉剪切点。',
        '某些位置需要在单侧或两侧有足够的源手柄。',
        '在选择兼容的片段或剪切点之前，点击应用可能不可用。',
      ],
    },
  ],
} satisfies DocPageContent

export default page